import { jsx as _jsx } from "react/jsx-runtime";
import EditableTimeInput from './EditableTimeInput';
var decimalHoursToMinutes = function (hours) {
    if (hours == null || isNaN(hours))
        return 0;
    return Math.round(Math.abs(hours) * 60) * (hours < 0 ? -1 : 1);
};
var minutesToDecimalHours = function (minutes) {
    if (minutes == null)
        return null;
    return minutes / 60;
};
var EditableDecimalHoursInput = function (_a) {
    var onChange = _a.onChange, value = _a.value, _b = _a.readOnly, readOnly = _b === void 0 ? false : _b, _c = _a.min, min = _c === void 0 ? 0 : _c, _d = _a.max, max = _d === void 0 ? 1439 : _d, _e = _a.displayClassName, displayClassName = _e === void 0 ? '' : _e, _f = _a.inputClassName, inputClassName = _f === void 0 ? '' : _f;
    var minuteValue = decimalHoursToMinutes(value);
    var displayValue = (value !== null && value !== void 0 ? value : 0).toTime();
    return (_jsx(EditableTimeInput, { onChange: function (minutes) { return onChange(minutesToDecimalHours(minutes)); }, value: minuteValue, displayValue: displayValue, readOnly: readOnly, min: min, max: max, displayClassName: displayClassName, inputClassName: inputClassName }));
};
export default EditableDecimalHoursInput;
